import './Input.css';
import { forwardRef } from 'react';

const TextArea = forwardRef((props, ref) => {
    return (
        <textarea {...props} ref={ref} />
    )
});


TextArea.defaultProps = {
    className : 'input full-width resize-area'
}

export default TextArea;